import { ref } from "vue";
export function useTiming(config) {
    const { stopCallBack } = config;
    const time = 60;
    const count = ref(time);
    let intervalId;
    const startCountdown = () => {
        intervalId = setInterval(() => {
            if (count.value > 0) {
                count.value--;
            }
            else {
                stopCountdown();
            }
        }, 1000);
    };
    const stopCountdown = () => {
        stopCallBack();
        count.value = time;
        clearInterval(intervalId);
    };
    return {
        count,
        startCountdown,
        stopCountdown
    };
}
